import { render } from "./PhotosIcon.vue?vue&type=template&id=fea2b960"
const script = {}
script.render = render

export default script